import { render, staticRenderFns } from "./ImageInput.vue?vue&type=template&id=8ba0bdf6&scoped=true&"
import script from "./ImageInput.vue?vue&type=script&lang=js&"
export * from "./ImageInput.vue?vue&type=script&lang=js&"
import style0 from "./ImageInput.vue?vue&type=style&index=0&id=8ba0bdf6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ba0bdf6",
  null
  
)

export default component.exports